"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var theme = function theme() {
  var _ref = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
      _ref$upperCaseOverrid = _ref.upperCaseOverride,
      upperCaseOverride = _ref$upperCaseOverrid === void 0 ? 'uppercase' : _ref$upperCaseOverrid;

  return {
    text: {
      textTransformUppercase: upperCaseOverride
    },
    palette: {
      background: {
        default: '#fff',
        paper: '#fafafa'
      },
      primary: {
        main: '#CE1F24'
      },
      secondary: {
        main: '#71962C',
        background: '#EFEFEF',
        adornment: {
          primary: '#EEBC12',
          blue: '#276FCE'
        }
      },
      borders: {
        primary: '#EAF2E2',
        default: 'rgba(0,0,0,.1)'
      },
      another: {
        tabs: '#BDBDBD',
        grey: '#9E9E9E',
        loginBtn: '#0099ff',
        cart: {
          background: '#ECECEE',
          borders: '#BCBDC0',
          radioColor: '#006600',
          grey: '#57585A'
        }
      }
    },
    typography: {
      fontFamily: '"Roboto", "Arial", sans-serif',
      h1: {
        fontSize: '30px',
        fontWeight: 300
      },
      h2: {
        fontSize: '24px',
        fontWeight: 300
      },
      h3: {
        fontSize: '18px',
        fontWeight: 300
      }
    },
    overrides: {
      AgreementField: {
        label: {
          paddingTop: 8
        }
      },
      SxComProductImageModal: {
        content: {
          alignItems: 'stretch'
        },
        activeImage: {}
      },
      SxComProductImageGalleryThumbnailsItem: {
        image: {
          maxHeight: 128,
          maxWidth: 128
        }
      },
      SxComProductImageGalleryThumbnails: {
        root: {
          marginTop: 16
        },
        horizontal: {
          width: '100%'
        },
        sliderWrapperInner: {
          width: '100%',
          justifyContent: 'flex-start',
          '&$horizontal': {
            width: '100%'
          }
        }
      },
      SxComCartSectionItem: {
        root: {
          paddingLeft: 0,
          paddingRight: 0,
          paddingTop: 0,
          paddingBottom: 0,
          '@media(max-width: 959px)': {
            paddingLeft: 16,
            paddingRight: 16
          }
        },
        variantHeader: {
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'space-between',
          width: '100%',
          backgroundColor: '#ECECEE',
          height: 56,
          '@media(min-width: 960px)': {
            paddingLeft: 24,
            paddingRight: 24
          }
        },
        variantContent: {
          borderBottom: '1px solid #BCBDC0'
        }
      },
      SxComAnchorContainer: {
        root: {
          position: 'relative'
        },
        anchor: {
          position: 'absolute',
          top: -54,
          '@media(max-width: 959px)': {
            top: -60
          }
        }
      },
      SxComProductImage: {
        'size-big-landscape': {
          width: '100%',
          height: '100%',
          maxHeight: 300,
          '@media(max-width: 959px)': {
            height: 'auto'
          }
        },
        'size-big-square': {
          width: '100%',
          height: '100%'
        },
        'size-mini-square': {
          height: 100,
          width: 100
        }
      },
      SxComProductImageGallery: {
        root: {
          position: 'relative'
        },
        image: {
          '@media(min-width: 960px)': {
            width: '100%',
            height: '100%'
          }
        },
        'variant-horizontal': {
          justifyContent: 'space-between'
        }
      },
      SxAdminAdministrationBlockItem: {
        root: {
          '@media(max-width: 599px)': {
            flexWrap: 'wrap'
          }
        },
        input: {
          '@media(max-width: 599px)': {
            width: '100%',
            '& > div': {
              width: '100%'
            }
          }
        }
      },
      AppBarActions: {
        about: {
          '@media(max-width: 600px)': {
            width: '100%',
            textAlign: 'center',
            paddingTop: 12
          }
        },
        container: {
          flexWrap: 'nowrap',
          '@media(max-width: 600px)': {
            flexWrap: 'wrap',
            justifyContent: 'center'
          }
        }
      },
      SxGlobalSearchField: {
        root: {
          '@media(max-width: 959px)': {
            maxWidth: '100%',
            marginBottom: 12
          }
        },
        inputRoot: {
          width: '100%'
        }
      },
      SxAppWebHeaderNarrow: {
        portal: {
          overflowY: 'auto',
          '@media(max-width: 960px)': {
            padding: 8
          }
        },
        menuButton: {
          '& svg': {
            width: 32,
            height: 32
          }
        }
      },
      SxComProductListItemCard: {
        root: {
          gridTemplateAreas: "\n          \"image        image\"\n          \"title        title\"\n          \"description  description\"\n          \"price        price\"\n          \"compare      addToCart\"\n          \"storage      storage\"\n        ",
          gridTemplateColumns: '1fr 1fr',
          height: 'auto',
          gridTemplateRows: 'auto minmax(45px, 60px) 60px auto 45px 25px',
          minWidth: 275,
          width: 290,
          padding: 16
        }
      },
      SxLayoutWebClassic: {
        content: {
          paddingTop: 24,
          '@media(max-width: 959px)': {
            paddingTop: 133
          },
          '@media(max-width: 599px)': {
            paddingTop: 98
          },
          '@media(max-width: 420px)': {
            paddingTop: 84
          }
        }
      },
      SxComProductDetailImageGallery: {
        root: {
          overflow: 'visible'
        }
      },
      SxHomepageJumbotron: {
        root: {
          overflow: 'hidden'
        }
      },
      SxAppWebHeaderWide: {
        appbar: {
          '@media(min-width: 600px)': {
            paddingLeft: '32px',
            paddingRight: '32px'
          }
        }
      },
      SxWebMainNavigationItemPopover: {
        root: {
          maxWidth: 1280
        }
      },
      SxComPaymentMethodItem: {
        root: {
          padding: '8px 0'
        },
        imageContainer: {
          margin: '0 12px',
          display: 'flex',
          justifyContent: 'flex-end',
          alignItems: 'center',
          width: '100%',
          maxWidth: 100
        },
        image: {
          maxWidth: 80,
          maxHeight: 60
        },
        typoContainer: {
          display: 'flex',
          flexDirection: 'column',
          width: '100%',
          maxWidth: 400,
          '& h5, & p': {
            margin: 0
          }
        }
      },
      SxFieldsPriceRangeSliderField: {
        slider: {
          color: '#3a8589',
          height: 3,
          padding: '13px 0'
        },
        thumb: {
          height: 20,
          width: 20,
          backgroundColor: '#bdbdbd',
          marginTop: -8,
          marginLeft: -8,
          borderRadius: 3,
          '&:after': {
            left: 0,
            right: 0
          },
          '&:focus,&:hover,&$active': {
            boxShadow: '#ccc 0px 2px 3px 1px'
          },
          '& .bar': {
            height: 9,
            width: 1,
            backgroundColor: 'currentColor',
            marginLeft: 1,
            marginRight: 1
          }
        },
        active: {},
        valueLabel: {
          left: 'calc(-50% + 4px)'
        },
        track: {
          top: 9,
          height: 12,
          background: '#CE1F24'
        },
        rail: {
          color: '#e0e0e0',
          opacity: 1,
          height: 12,
          top: 9
        }
      },
      SxComListDiscountedPricePreviewNaked: {
        discount: {
          position: 'absolute',
          left: 0,
          top: '50%',
          transform: 'translate(0,-50%)',
          width: 115,
          height: 64,
          background: '#CE1F24',
          color: '#fff',
          display: 'flex',
          justifyContent: 'center',
          alignItems: 'center',
          borderRadius: 6,
          fontSize: 20,
          fontWeight: 500
        },
        value: {
          fontSize: 20,
          fontWeight: 300,
          marginRight: 0,
          '& > span': {
            display: 'flex',
            width: 'auto'
          }
        }
      },
      SxComProductPrice: {
        fullWidth: {
          position: 'relative',
          display: 'flex',
          flexDirection: 'column',
          paddingRight: 8,
          '& > span': {
            width: 'auto'
          }
        }
      },
      SxShoppingCartButtonAddToCart: {
        root: {
          width: 'auto'
        }
      },
      SxComProductPriceElementBase: {
        sizeMedium: {
          fontSize: 18,
          '@media(max-width: 959px)': {
            fontSize: 15
          }
        },
        colorTextSecondary: {
          color: '#A8A9AD'
        },
        sizeLarge: {
          fontSize: 45,
          fontWeight: 300,
          '@media(max-width: 959px)': {
            fontSize: 35
          }
        }
      },
      SxComProductDetailLink: {
        root: {
          color: '#000',
          fontWeight: 300,
          '@media(min-width: 600px)': {
            fontSize: 18
          }
        }
      },
      SxComProductParameter: {
        root: {
          paddingLeft: 24
        }
      },
      SxShoppingCartQuantityField: {
        root: {
          width: 'auto',
          margin: 0
        },
        button: {
          '& svg': {
            width: 18,
            height: 18
          }
        },
        input: {
          maxWidth: 45
        }
      },
      SxComProductParametersListItemGroup: {
        tooltip: {
          borderBottom: '1px solid #000'
        }
      },
      SxComProductImgListItem: {
        root: {
          '&:first-of-type': {
            borderLeft: '1px solid rgba(0,0,0,.1)'
          },
          '&:last-of-type': {
            borderRight: 'none'
          }
        }
      },
      SxAppCatalogueCarousel: {
        content: {
          '& > div': {
            flexBasis: 0
          }
        }
      },
      SxComProductImgListWithTitle: {
        title: {
          color: '#CE1F24',
          fontSize: 24,
          fontWeight: 300,
          lineHeight: 1.6,
          letterSpacing: 0.3,
          textTransform: upperCaseOverride,
          textDecoration: 'underline'
        },
        content: {
          '& > div': {
            flexGrow: 0
          }
        }
      },
      SxComProductAvailabilityFieldPreviewNaked: {
        root: {
          color: '#539E55',
          fontSize: 13
        }
      },
      PrivateTabIndicator: {
        root: {
          display: 'none'
        },
        colorSecondary: {
          backgroundColor: 'transparent'
        }
      },
      // __________________________________ MATERIAL UI __________________________________
      MuiTypography: {
        h1: {
          '@media(min-width: 0px)': {
            fontSize: 36
          }
        },
        h2: {
          textDecoration: 'underline',
          textTransform: upperCaseOverride,
          fontWeight: 600,
          lineHeight: 1.6,
          letterSpacing: 0.3,
          color: '#CE1F24',
          '@media(min-width: 0px)': {
            fontSize: 22
          }
        },
        h3: {
          color: '#000',
          textTransform: upperCaseOverride,
          fontSize: 22,
          '@media(min-width: 600px)': {
            fontSize: 22
          }
        },
        h4: {
          color: '#000',
          fontWeight: 600,
          '@media(min-width: 600px)': {
            fontSize: 18
          }
        },
        h5: {},
        h6: {},
        caption: {
          '@media(min-width: 600px)': {
            fontSize: 15
          }
        },
        body1: {},
        body2: {
          '@media(min-width: 600px)': {
            fontSize: 14
          }
        }
      },
      MuiTab: {
        root: {
          border: '1px solid #000',
          borderRadius: 3
        },
        textColorInherit: {
          '&:not(:last-of-type)': {
            marginRight: 16
          },
          color: '#000',
          fontWeight: 600
        }
      },
      MuiBadge: {
        colorSecondary: {
          backgroundColor: '#CE1F24'
        }
      },
      MuiChip: {
        label: {
          display: 'flex'
        }
      },
      MuiButton: {
        root: {
          textTransform: upperCaseOverride
        }
      }
    }
  };
};

var _default = theme;
exports.default = _default;